import React  from 'react';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import GlobalDbnTaxonomyCategoryBasicInfoComponent from './global-dbn-taxonomy-category-basic-info.component';
import GlobalDbnTaxonomyCategoryAccountMappings from './global-dbn-taxonomy-category-account-mappings';
import MediaInfoComponent from '../../../../common/components/common/media-info.component';
import { useAppSelector } from '../../../../hooks/hooks';
import { selectListItems } from '../../../../redux/library/selector';

export const GlobalDbnTaxonomyCategoriesComponent = ({domains,setFunctionAttributes,functionAttributes,id, entityAttributes,setEntityAttributes,parentCategory,handleInnerFormChange,selectedCategory, handleFormItemChange, mediaFiles, changeImage, 
  categories, back,handleFormSubmit}: any) => {
    const libraryData = useAppSelector(selectListItems)

  const tabItems=[
    {
        id:1,
        title:'Basic Information',
        component:<GlobalDbnTaxonomyCategoryBasicInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedCategory={selectedCategory}
        parentCategory={parentCategory}
        domains={domains}
        />,
    isVisible:true,
    },
    // {
    //     id: 2,
    //     title: 'Entity Attributes',
    //     component: 
    //     <OpennetworkCategoryFunctionAndEntityAttributeComponent
    //         entityAttributes={entityAttributes}
    //         setEntityAttributes={setEntityAttributes}
    //         functionAttributes={functionAttributes}
    //         setFunctionAttributes={setFunctionAttributes}
    //         id={id}
    //       />,
    //       isVisible: id > 0 ? true : false,
    //   },
    {
      id: 3,
      title: 'Media',
      component:
        <MediaInfoComponent
          changeImage={changeImage}
          // deleteSelectedProduct={deleteSelectedCategory}
          fileTypes={libraryData?.result?.FileType}
          //handleClose={handleClose}
          //handleOpen={handleOpen}
          onFormItemChange={handleFormItemChange}
          // openConfirmation={openConfirmation}
          mediaFiles={mediaFiles}
        //uploadToDigiiFolder={uploadToDigiiFolder}
        />,
      isVisible: id > 0 ? true : false,
    },
    {
      id: 4,
      title: 'DBA Mappings',
      component:
        <GlobalDbnTaxonomyCategoryAccountMappings selectedCategory={selectedCategory}/>,
      isVisible: id > 0 ? true : false,
    },
    
  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default GlobalDbnTaxonomyCategoriesComponent;
